import { HashRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import SedesParametros from "./pages/SedesParametros";
import { ReactLogo } from "./pages/ReactLogo";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/:id" element={<SedesParametros />} />
        </Routes>
      </Router>
      <ReactLogo />
    </div>
  );
}

export default App;
